import styles from './Items.module.css';

import { memo } from 'react';

import Typography from '@mui/material/Typography';

import { ItemsListHeader } from './ItemsListHeader';
import { Item } from '../Item/Item';

export const ItemsList = memo(({ user, items, selectedItems, onCheckboxChange, onSelectAll, onSaveItem, onCancel }) => {
    const handleCheckboxChange = (item, checked) => {
        onCheckboxChange(item, checked);
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <>
            <ItemsListHeader items={ items } selectedItems={ selectedItems } onSelectAll={ onSelectAll } />

            <div className={ styles.items } >
                { items.length > 0 ? items.map(f => {
                    return (
                        <Item
                            key={ f.id }
                            user={ user }
                            item={ f }
                            checked={ selectedItems.some(i => i.id === f.id) }  // Add checked prop
                            onCheckboxChange={ handleCheckboxChange }
                            onSaveItem={ onSaveItem }
                            onCancel={ handleCancel }
                        />
                    );
                }) : (
                    <Typography variant="body1" sx={ { p: 2 } }>
                        No items found.
                    </Typography>
                ) }
            </div>
        </>
    );
});

ItemsList.displayName = 'Items List';